module.exports = __webpack_public_path__ + "img/columns-1.f4a0a5ed.jpeg";